/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Arbeitsvertragids2Inputs */



/**

* @param {_Field_Arbeitsvertragids2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_arbeitsvertragids2 = /** @type {((inputs?: _Field_Arbeitsvertragids2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Arbeitsvertragids2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Arbeitsverträge")
});
export { _field_arbeitsvertragids2 as "_field_arbeitsvertragIDs" }